const en = {
  nav: {
    about: "About AIRDOA",
    yokohama: "Yokohama Heli Cruise",
    pricing: "Pricing & Plans",
    firstTime: "First Time",
    faq: "FAQ",
    access: "Access",
    gift: "Gift Tickets",
    column: "Articles",
    company: "Company",
    contact: "Contact",
    viewYokohama: "View Yokohama Heli Cruise",
  },
  common: {
    viewYokohama: "View Yokohama Heli Cruise",
    viewPricing: "View Pricing & Plans",
    buyGift: "Buy Gift Ticket",
    inquire: "Inquire About Booking",
    viewDetails: "View Details",
    viewAll: "View All",
    bookNow: "Book Now",
    contact: "Contact Us",
    purchase: "Purchase",
    seeMore: "See More",
    popular: "Popular",
    preparing: "Coming Soon",
    available: "Available Now",
  },
  mobile: {
    pricing: "View Pricing",
    contact: "Contact",
    gift: "Buy Gift",
  },
  footer: {
    tagline: "Make the Yokohama Sky\nYour Special Memory.",
    categories: {
      booking: "Book Experience",
      guide: "User Guide",
      about: "About AIRDOA",
      support: "Support",
    },
    links: {
      yokohama: "Yokohama Heli Cruise",
      pricing: "Pricing & Plans",
      gift: "Gift Tickets",
      firstTime: "First Time",
      faq: "FAQ",
      access: "Access",
      baggage: "Baggage Restrictions",
      flow: "Day-of Flow",
      bookingFlow: "Booking Process",
      cancelPolicy: "Cancellation Policy",
      company: "Company",
      column: "Articles",
      reviews: "Customer Reviews",
      news: "News",
      contact: "Contact",
      privacy: "Privacy Policy",
      tokushoho: "Specified Commercial Transactions",
      sitemap: "Sitemap",
    },
    copyright: "AIRDOA. All rights reserved.",
    privacy: "Privacy Policy",
    tokushoho: "Specified Commercial Transactions",
  },
  home: {
    hero: {
      badge: "Yokohama Helicopter Cruise Booking Media",
      title: "Experience Yokohama\nFrom the Sky",
      subtitle: "AIRDOA is a premium booking media for helicopter sightseeing tours in Yokohama. Perfect for anniversaries and dates, with easy guidance for first-time visitors. Breathtaking views that can't be seen from the ground.",
      ctaPrimary: "View Yokohama Heli Cruise",
      ctaSecondary: "View Pricing & Plans",
    },
    about: {
      label: "ABOUT AIRDOA",
      title: "What is AIRDOA?",
      description: "AIRDOA is a specialized web media platform for booking helicopter sightseeing tours. We aim to provide safe, high-quality booking experiences for special occasions — anniversary dates, proposals, sightseeing, and gifts. Yokohama from the sky delivers an emotion that the ground simply cannot.",
      point1Title: "Easy Booking Platform",
      point1Desc: "Simple online consultations. Our dedicated staff will suggest the perfect plan for you.",
      point2Title: "Uncompromising Safety",
      point2Desc: "We only partner with MLIT-certified operators, rigorously verifying maintenance records and pilot credentials.",
      point3Title: "Perfect for Anniversaries",
      point3Desc: "Ideal for proposals, birthdays, and wedding anniversaries. Gift wrapping and special arrangements available.",
    },
    yokohama: {
      label: "FEATURED AREA",
      title: "Yokohama Heli Cruise",
      subtitle: "A special experience viewing Yokohama's iconic night scenery not from the ground, but from the sky. Enjoy a panoramic view of Minato Mirai's skyscrapers, the Bay Bridge, and Red Brick Warehouse.",
      cta: "View Yokohama Experience",
      stat1Value: "~15 min",
      stat1Label: "Shortest Course",
      stat2Value: "2+ pax",
      stat2Label: "Capacity",
      stat3Value: "Night View",
      stat3Label: "Most Popular",
    },
    strengths: {
      label: "WHY AIRDOA",
      title: "Why Choose AIRDOA",
    },
    scenes: {
      label: "SCENES",
      title: "Perfect for These Occasions",
    },
    plans: {
      label: "PLANS",
      title: "Recommended Yokohama Plans",
      subtitle: "Choose the perfect course to match your purpose and budget",
      inquire: "Please inquire",
      popular: "Popular",
    },
    steps: {
      label: "FIRST TIME",
      title: "For First-Time Visitors",
      subtitle: "Even on your first helicopter tour, you can enjoy it with peace of mind. Our dedicated staff will guide you every step of the way.",
      cta: "First-Time Visitor Guide",
      step1Title: "Easy Online Consultation",
      step1Desc: "Simply enter your desired date, time, and number of guests. Our staff will suggest the best plan.",
      step2Title: "Pre-Departure Preparation",
      step2Desc: "We'll guide you on attire, what to bring, and the day-of schedule. Feel free to ask us anything beforehand.",
      step3Title: "Your Special Experience",
      step3Desc: "After check-in at the heliport, you'll take off with the pilot. Breathtaking scenery awaits.",
    },
    safety: {
      label: "SAFETY",
      title: "Safety-First Operations",
      subtitle: "We select operating partners under strict safety standards, putting our customers' safety first",
    },
    faq: {
      label: "FAQ",
      title: "Frequently Asked Questions",
      cta: "View More Questions",
    },
    access: {
      label: "ACCESS",
      title: "Access to the Heliport",
      cta: "View Access Details",
    },
    gift: {
      label: "GIFT",
      title: "A Sky Gift for Someone Special",
      cta: "Purchase Gift Ticket",
    },
    column: {
      label: "COLUMN",
      title: "Latest Articles",
      subtitle: "Tips on Yokohama dates, helicopter tours, and gift ideas",
      cta: "View All Articles",
    },
    reviews: {
      label: "VOICE",
      title: "Customer Reviews",
      subtitle: "Testimonials from guests who have experienced our tours",
      cta: "View More Reviews",
    },
    areas: {
      label: "AREAS",
      title: "Future Expansion Areas",
      subtitle: "The following areas are currently in preparation. Bookings will open soon.",
    },
    finalCta: {
      title: "Experience Yokohama\nFrom the Sky",
      subtitle: "Views that can't be seen from the ground, shared with someone you love",
    },
  },
};

export default en;
